/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import MasterService from "../../../../services/MasterService";
import pracicoSvg from "../../../../public/practitioners-ico.svg";
import vector3Svg from "../../../../public/Vector_3.svg";
import vector2Svg from "../../../../public/Vector_2.svg";
import vector1Svg from "../../../../public/Vector_1.svg";
import aycSvg from "../../../../public/ayushchairs-ico.svg";
import assSvg from "../../../../public/association-ico.svg";
import { showLoading } from "react-global-loading";
class CountriesDetails extends React.Component {
  constructor(props) {
    super(props);
    showLoading(true);
    const query = this.props.location?.search
      ? new URLSearchParams(this.props.location.search)
      : "";

    this.state = {
      countryId: query ? query.get("id") : "",
      countryDetails: "",
    };
  }

  componentDidMount = () => {
    this.getCountryDetails();
  };

  getCountryDetails = () => {
    MasterService.getCountryDetails(this.state.countryId)
      .then(result => {
        if (!result) {
          return;
        }
        this.setState({ countryDetails: result[0] });

        showLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  };

  render() {
    const { countryDetails, countryId } = this.state;
    return (
      <>
        <div className="container-fluid" id="main">
          <div className="row d-flex align-items-center justify-content-center">
            {/* <div className="col-md-9 mt-2">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><a href="#">Home</a></li>
                  <li className="breadcrumb-item active" aria-current="page">View Countries</li>
                </ol>
              </nav>
            </div> */}
            {/* <div className="col-md-3 text-end mt-4">
              <span
                className="text-primary"
                onClick={() => window.history.back()}
              >
                <i className="fa fa-angle-double-left" aria-hidden="true"></i>{" "}
                Back
              </span>
              <Link
                to={{
                  pathname: "/super/edit-country",
                  search: `?id=${countryId}`,
                  state: { editData: countryDetails },
                }}
                className="text-primary"
              >
                {" "}
                Edit
              </Link>
            </div> */}
          </div>

          <hr></hr>
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-md-12">
                  <h4 className="fs-3 cdhd">
                    <div className="inll">
                      <span className="linear-title">
                        <b>{countryDetails?.post_title}</b>
                      </span>
                      <span className="badge text-bg-light text-primary-emphasis mx-3 site-link">
                        Visit Embassy Website{" "}
                        <i
                          className="fa fa-external-link-square fs-4"
                          aria-hidden="true"
                        />
                      </span>
                    </div>
                    <Link
                      to={{
                        pathname: "/super/edit-country",
                        search: `?id=${countryId}`,
                        state: { editData: countryDetails },
                      }}
                      className=" btn theme-btn-fill"
                    >
                      {" "}
                      Edit Country Data
                    </Link>
                  </h4>
                  <p>Welcome back, we're happy to have you here!</p>
                </div>

                {/* <div className="col-md-3 text-end">
                  <button type="button" className="btn theme-btn-outline">
                    Edit Country Details
                  </button>
                </div> */}
              </div>
              <div className="row border rounded rounded-3 p-2 top-fea">
                <div className="col-md-2">
                  <small className="text-body-secondary fs-6">
                    Mission Users
                  </small>
                  <p>
                    <b>{countryDetails.t_missionusers}</b>
                    {/* <Link to="/"><span className="badge bg-info-subtle fw-bold text-dark mx-2">Create</span></Link> */}
                  </p>
                </div>
                <div className="col-md-2">
                  <small className="text-body-secondary fs-6">
                    Practitioners
                  </small>
                  <p>
                    <b>{countryDetails.t_practiceusers}</b>
                    {/* <Link to="/"><span className="badge bg-info-subtle fw-bold text-dark mx-2">Create</span></Link> */}
                  </p>
                </div>

                <div className="col-md-2">
                  <small className="text-body-secondary fs-6">Products</small>
                  <p>
                    {" "}
                    <b>{countryDetails.t_products}</b>
                    {/* <Link to="/"><span className="badge bg-info-subtle fw-bold text-dark mx-2">Create</span></Link> */}
                  </p>
                </div>
                <div className="col-md-2">
                  <small className="text-body-secondary fs-6">Events</small>
                  <p>
                    <b>{countryDetails.t_events}</b>
                    {/* <Link to="/"><span className="badge bg-info-subtle fw-bold text-dark mx-2">Create</span></Link> */}
                  </p>
                </div>
                <div className="col-md-2">
                  <small className="text-body-secondary fs-6">Schemes</small>
                  <p>
                    <b>{countryDetails.t_schemes}</b>
                    {/* <span className="badge bg-info-subtle fw-bold text-dark mx-2">Create</span> */}
                  </p>
                </div><div className="col-md-2">
                  <small className="text-body-secondary fs-6">documents</small>
                  <p>
                    <b>{countryDetails.t_documents}</b>
                    {/* <span className="badge bg-info-subtle fw-bold text-dark mx-2">Create</span> */}
                  </p>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-9">
                  <h4>Country Domains</h4>
                  <div className="domains mt-3">
                    {countryDetails?.domains?.length > 0 &&
                      countryDetails?.domains[0]?.map((domainItem, index) => (
                        <span
                          key={index}
                          className="badge rounded-pill text-bg-morelight fw-normal"
                        >
                          {domainItem}
                        </span>
                      ))}
                  </div>
                  {countryDetails?.post_content && <h4 className="mt-4">Country Description</h4>}
                  <p>{countryDetails?.post_content} </p>
                  {countryDetails?.opportunity && <h4 >Opportunity for students</h4>}
                  <p>{countryDetails?.opportunity} </p>
                  {countryDetails?.mou && <h4 >MoUs</h4>}
                  <p>{countryDetails?.mou} </p>
                  {countryDetails?.info_cell && <h4 >Information cell</h4>}
                  <p>{countryDetails?.info_cell} </p>
                  {countryDetails?.rules_regulation && <h4 >Rules Regulation</h4>}
                  <p>{countryDetails?.rules_regulation} </p>
                  {countryDetails?.ayush_chair && <h4 >Ayush Chairs</h4>}
                  <p>{countryDetails?.ayush_chair} </p>
                </div>
                <div className="col-md-3 border rounded rounded-4 p-3 profile-details">
                  <div className="side-details">
                    <img
                      src={require("../../../../public/proavatar.png")}
                      className="float-start me-4"
                      alt="avatar"
                    />
                    <h5>{countryDetails?.embassy_person}</h5>
                    <span className="text-body-secondary">
                      <i className="fa fa-envelope" aria-hidden="true"></i>{" "}
                      {countryDetails?.email}
                    </span>{" "}
                    <span className="text-body-secondary mx-4">
                      {" "}
                      <i
                        className="fa fa-phone-square"
                        aria-hidden="true"
                      ></i>{" "}
                      {countryDetails?.phone}
                    </span>
                    <h5 className="mt-4">Location</h5>
                    <p>{countryDetails?.mission_address}</p>
                  </div>
                  {/* <h5 className="mt-4">Joined</h5>
                  <p>6 Dec 2020</p> */}
                  {/* <div className="mail-btn">
                    <button type="button" className="btn theme-btn-fill w-100">
                      <i className="fa fa-envelope-o" aria-hidden="true"></i>{" "}
                      E-mail User
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default CountriesDetails;
